import * as types from '../constants/ActionTypes'

const showactivecall = (state = [], action) => {
    switch (action.type) {
      case 'ADD_ACTIVECALL':
      return {
          type: "ADD_ACTIVECALL",
          showactivecall: action.showactivecall
        }
      default:
        return state
    }
  }
  
  export default showactivecall
  